// extracted by mini-css-extract-plugin
export default {"container":"Lp-z","heading":"Mp-z","text":"Np-z","info":"Op-z","link":"Pp-z","fullMaxWidth":"Qp-z"};